<template>
    <div class="back_img">
        <!-- 登录框-->
        <div class="login_box">
            <img src="images/login.jpg">
            <avue-login :option="option" @submit="submit" class="loginForm"></avue-login>
        </div>
        <!-- 背景跑马灯-->
        <div class="banner">
            <ul id="imgList" class="img_list">
                <li :class="bannerCompute === 0 ? 'on' : ''" style="background: url(images/bg0.jpg);"></li>
                <li :class="bannerCompute === 1 ? 'on' : ''" style="background: url(images/bg1.jpg);"></li>
                <li :class="bannerCompute === 2 ? 'on' : ''" style="background: url(images/bg2.jpg);"></li>
                <li :class="bannerCompute === 3 ? 'on' : ''" style="background: url(images/bg3.jpg);"></li>
            </ul>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        bannerIndex: 0,
        option: {
          width: 400,
          column: {
            username: {
              label: '用户名',
              autocomplete: 'off',
              rules: {required: true, message: '请输入用户名', trigger: 'blur'}
            },
            password: {
              label: '密码',
              autocomplete: 'off',
              rules: {required: true, message: '请输入密码', trigger: 'blur'}
            },
            code: {
              hide: true
            }
          }
        }
      }
    },

    methods: {
      submit(form) {
        this.api.get('/login', form).then((re) => {
            if (re === undefined) {
              this.$message.error("登录失败,网络错误!");
              return
            }
            if (re && re.code === 0) this.$store.commit('login', re)
            else this.$message.error(re.msg)
          }
        )
      }
    },
    created() {
      // 计时器
      setInterval(()=> {
        if (this.bannerIndex === 3) {
          this.bannerIndex = 0
        } else {
          this.bannerIndex += 1
        }
      }, 6000)
    },
    computed: {
      bannerCompute() {
        return this.bannerIndex
      }
    }
  }
</script>

<style scoped>
    /*banner外框*/
    .banner, html, body {
        width: 100%;
        height: 100%;
        position: relative;
        background: #FFFFFF;
    }

    /*图片透明度-时间与JS相对应*/
    .img_list li {
        position: absolute;
        transition: all 3s ease;
        opacity: 0;
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        background-position: center;
        list-style-type: none;
    }

    .img_list {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    /*被选中时*/
    .img_list .on {
        display: block;
        opacity: 1;
    }


    .back_img {
        height: 100%;
        width: 100%;
        background-size: cover;
        background-position: center;
    }

    .login_box {
        width: 1000px;
        height: 500px;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -35%);
        z-index: 3;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        box-shadow: 8px 8px 10px #00000042;
        overflow: hidden;
        background: #FFFFFF;
    }

    .login_box img {
        float: left;
    }

    .loginForm {
        float: right;
        margin-top: 120px;
        margin-right: 40px;
    }

</style>
